import i18n from '@/utils/i18n';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { Keyboard, TouchableOpacity } from 'react-native';
import { KeyboardBar } from '@/experiences/sales-portal/components/keyboard-bar';
import { Typography } from '@usepepper/sprout-kit-ui';

const DONE_BUTTON_HEIGHT = 32;

interface OrderEntryMobileKeyboardDoneBarProps {
  isVisible: boolean;
}

export const OrderEntryMobileKeyboardDoneBar: React.FC<
  OrderEntryMobileKeyboardDoneBarProps
> = ({ isVisible }) => {
  const [styles] = useStyles();
  const label = i18n.t('done');

  return (
    <KeyboardBar isVisible={isVisible} surface="tertiary">
      <TouchableOpacity
        accessibilityLabel={label}
        accessibilityRole="button"
        onPress={Keyboard.dismiss}
        style={styles.button}
      >
        <Typography color="$textPrimary" size="$sm" variant="label">
          {label}
        </Typography>
      </TouchableOpacity>
    </KeyboardBar>
  );
};

const useStyles = createStyles((theme) => ({
  button: {
    alignItems: 'center',
    height: DONE_BUTTON_HEIGHT,
    justifyContent: 'center',
    paddingHorizontal: theme.sk.spacing.spaceSMedium,
  },
}));
